import { gql, useQuery } from "@apollo/client";
import styled from "@emotion/styled";
import { AspectRatio, AspectRatios, ColorVariants, Column, Grid, GridColumn, Heading, Image, MediaQueries, Orientations, Paragraph, PrimaryAnchorButton, Section, Sizes, Spacer, Spacings, } from "@polestar/component-warehouse-react";
import * as React from "react";
import { errorQuery } from "../../../data";
import { useCurrentMarket } from "../../../index";
export const StaticError = React.forwardRef((props, ref) => {
    const { title, message, image, buttonLabel, buttonProps } = props;
    return (React.createElement(Wrapper, { ref: ref },
        React.createElement(Section, null,
            React.createElement(StyledGrid, null,
                React.createElement(GridColumn, { span: { mobile: 4 } },
                    React.createElement(StyledContentColumn, { mainAxisAlignment: "center", stretch: true },
                        React.createElement(Heading, null, title),
                        React.createElement(Spacer, { orientation: Orientations.vertical, spacing: Spacings.large }),
                        React.createElement(StyledParagraph, { size: Sizes.medium }, message),
                        React.createElement(Spacer, { orientation: Orientations.vertical, spacing: Spacings.xLarge }),
                        React.createElement(ButtonWrapper, null,
                            React.createElement(PrimaryAnchorButton, { rel: buttonProps.target === "_blank"
                                    ? "noreferrer noopener"
                                    : buttonProps.rel, variant: ColorVariants.black, ...buttonProps }, buttonLabel)))),
                React.createElement(GridColumn, { span: {
                        desktop: 8,
                        tablet: 8,
                        mobile: 4,
                    } },
                    React.createElement(StyledContentColumn, { mainAxisAlignment: "center", stretch: true },
                        React.createElement(ImageContainer, null,
                            React.createElement(AspectRatio, { ratio: AspectRatios.xWide },
                                React.createElement(Image, { alt: image.alt || "", src: image.url, showLoadingState: false })))))))));
});
const Wrapper = styled.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;

  padding-top: ${Spacings.xxxLarge};
  padding-bottom: ${Spacings.xxxLarge};

  ${MediaQueries.tablet} {
    padding-top: 0;
    padding-bottom: 0;
  }
`;
const StyledGrid = styled(Grid) `
  display: block;

  ${MediaQueries.tablet} {
    display: grid;
  }
`;
const StyledContentColumn = styled(Column) `
  ${MediaQueries.tablet} {
    height: 100%;
  }
`;
const ButtonWrapper = styled.div `
  display: inline-block;
`;
const StyledParagraph = styled(Paragraph) `
  white-space: pre-wrap;
`;
const ImageContainer = styled.div `
  margin-top: ${Spacings.xxLarge};

  ${MediaQueries.tablet} {
    margin-top: 0;
    margin-left: -${Spacings.xxLarge};
    margin-right: -${Spacings.xxLarge};
  }
  ${MediaQueries.desktop} {
    margin-left: 0;
    margin-right: -${Spacings.xxxxLarge};
  }
`;
export const query = (locale) => gql `{
  ${errorQuery(locale, "errorPageData")}
}`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ConnectedError = (props) => {
    const market = props.market || useCurrentMarket();
    if (!market) {
        console.error("Couldn't determine market, please pass a market via the props or use the MarketProvider");
        return null;
    }
    // Create an empty apollo options object
    const apolloOptions = {};
    // Set custom client if available
    // Use client from context otherwise
    if (props.client) {
        apolloOptions.client = props.client;
    }
    // Set custom context if available
    if (props.queryContext) {
        apolloOptions.context = props.queryContext;
    }
    const { cmsLocale } = market;
    const { data, error, loading } = useQuery(query(cmsLocale), apolloOptions);
    if (error) {
        console.error(error);
        return null;
    }
    if (loading) {
        return null;
    }
    if (!data.errorPageData) {
        console.error('no "error page" data found');
        return null;
    }
    return (React.createElement(StaticError, { ...data.errorPageData, buttonProps: props.buttonProps }));
};
StaticError.displayName = "Error";
ConnectedError.displayName = "ConnectedError";
